export default __webpack_public_path__ + "static/join04-07b98fac1a654dd763b4e6ff6a5fd636.png";